import { TLC_CONSTANTS } from "../../../../js/lib/tlc-constants";
import { TLCEventManager } from "../../../../js/lib/events/EventManager";
import { LS2PAC_CONSTANTS } from "../../../../js/main/constants";
import { ApplicationData } from "../ApplicationData";
import { LS2PacSearchDatabaseManager } from "../managers/SearchDatabaseManager";
import { renderInShadow } from "../../../../js/lib/components/ShadowUtils";
import * as React from 'react';
import { ResultsViewToggle } from "../../../../js/lib/components/ResultsViewToggle";

export const ChangeViewControl = (function ($) {
  var id = LS2PAC_CONSTANTS.Ids.SearchPage.changeViewControl;
  const removeListenerFunctions = [];
  
  return {
    init: function () {
      this.addListeners();
      this.render();
    },
    render: () => {
      const value = ApplicationData.getCurrentResultsView();
      const container = document.getElementById(id);
      const handleChange = (event,
        newView) => {
        ApplicationData.setCurrentResultsView(newView);
    
          if (newView != "flowView") {
            $("#" + LS2PAC_CONSTANTS.Ids.SearchPage.resultsSidePanel).show();
          } else {
            $("#" + LS2PAC_CONSTANTS.Ids.SearchPage.resultsSidePanel).hide();
          }
    
          TLCEventManager.fireEvent(
            LS2PAC_CONSTANTS.Events.onChangeResultsView,
            { viewName: newView }
          );
      };
      renderInShadow(<ResultsViewToggle value={value} onChange={handleChange}></ResultsViewToggle>, container, ApplicationData.language);
    },
    handleToggle: function (changeLayoutSupported) {
      if (changeLayoutSupported) {
        $("#" + id).show();
      } else {
        $("#" + id).hide();
      }
    },
    addListeners: function () {
      var _this = this;
      const pagingGuid = TLCEventManager.addListener(
        TLC_CONSTANTS.Events.onPagingModelResponse,
        function (event) {
          _this.handleToggle(event.data.changeLayoutSupported);
        }
      );
      removeListenerFunctions.push(() => TLCEventManager.removeListener(TLC_CONSTANTS.Events.onPagingModelResponse, pagingGuid));
      const searchGuid = TLCEventManager.addListener(
        LS2PAC_CONSTANTS.Events.onSearch,
        function (event) {
          _this.handleToggle(
            LS2PacSearchDatabaseManager.getCurrentDatabaseConfig()
              .changeLayoutSupported
          );
        }
      );
      removeListenerFunctions.push(() => TLCEventManager.removeListener(LS2PAC_CONSTANTS.Events.onSearch, searchGuid));
      const switchDBGuid = TLCEventManager.addListener(
        LS2PAC_CONSTANTS.Events.onSwitchSearchDatabase,
        function (event) {
          _this.handleToggle(
            LS2PacSearchDatabaseManager.getCurrentDatabaseConfig()
              .changeLayoutSupported
          );
        }
      );
      removeListenerFunctions.push(() => TLCEventManager.removeListener(LS2PAC_CONSTANTS.Events.onSwitchSearchDatabase, switchDBGuid));
    },
    cleanup: function() {
      removeListenerFunctions.forEach((remove) => remove());
    }
  };
})(jQuery);
